export default __webpack_public_path__ + "static/media/GOLFTEC_Logo_black.5177acee.jpg";